import { API_URL_V3 } from '../../../utils/config';
import { MY_INFO_CALL_BACK_URL } from '../../../utils/constants';
import { handleError } from '../common-message/message-action';
import { makeApiCall } from '../common/common-action';

const BASE_ORIGIN = window.location.origin;

export function getMyInfoRedirectUrl(isRfiFlow = false, rfiId = null) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/myinfo`,
        withCredentials: true,
        data: {
          redirect_url: `${BASE_ORIGIN}${MY_INFO_CALL_BACK_URL}`
        }
      });
      if (response && response.data && response.data.data) {
        // If its an RFI SINGPASS flow - set LS to work with callback url once redirected back
        if (isRfiFlow) localStorage.setItem('SINGPASS_RFI_FLOW', rfiId);
        window.location = response.data.data.myinfo_redirect_url;
      }
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

export function getMyInfoPersonalData(code, state, url, isRfi = false) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL_V3}/myinfo/person-data`,
        withCredentials: true,
        data: {
          code,
          state,
          redirect_url: `${BASE_ORIGIN}${MY_INFO_CALL_BACK_URL}`
        }
      });
      if (response?.data?.success && response.data.data?.success && !isRfi) {
        window.location = BASE_ORIGIN + url;
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}
